// extracted by mini-css-extract-plugin
module.exports = {"bigPlayButton":"ensureGlobalClick__bigPlayButton__jSzza"};